/**
 * @fileoverview GET handler for the "/apps/:app_group_id/charts/attribute_names" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsAppGroupIdChartsAttributeNames } from "./constants";
import type { AppsAppGroupIdChartsAttributeNamesResult } from "./types";
import { isAppsAppGroupIdChartsAttributeNamesResult } from "./validators";

export const getAppsAppGroupIdChartsAttributeNames = reactQueryFetcherAdapter(
  appsAppGroupIdChartsAttributeNames,
  (
    signal: AbortSignal,
    appGroupId: string,
    query: string,
    limit: number
  ): Promise<AppsAppGroupIdChartsAttributeNamesResult> => {
    return fetch<AppsAppGroupIdChartsAttributeNamesResult>(
      `/apps/${appGroupId}/charts/attribute_names`,
      "GET",
      { query, limit },
      { signal }
    );
  },
  isAppsAppGroupIdChartsAttributeNamesResult
);
